export interface ManageBudget {

}
export interface CreateBudget {
    financial_year: string,
    total_financial_budget: string,
    budget_id?: string;
    Q1_Budget: string,
    Q2_Budget: string,
    Q3_Budget: string,
    Q4_Budget: string,
}
export interface BudgetsList {
    financial_year: string,
    total_financial_budget: string,
    Q1_Budget: string,
    Q2_Budget: string,
    Q3_Budget: string,
    Q4_Budget: string,
}
export interface BudgetDetail {
    budget_aligned: string,
    budget_financial_year: string,
    budget_id: string,
    createdBy: string,
    created_on: string,
    createdbyFirst_name: string,
    createdbyLast_name: string,
    customer_id: string,
    customer_name: string,
    fv_investment_budget:string,
    pendingamount: string,
    q1_budget: string,
    q2_budget: string,
    q3_budget: string,
    q4_budget: string,
    spend: string,
}

